import { useLang } from "../contexts/LangContext";
import Logo from "./Logo";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t" style={{ borderColor: "hsl(var(--border))" }}>
      <div className="mx-auto max-w-[1400px] px-5 py-14 sm:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <Logo size={36} color="hsl(var(--ink))" />
              <div className="font-display text-xl text-ink">606MEDIADOCS</div>
            </div>
            <p className="mt-4 max-w-sm text-sm text-muted-fg">{t("tagline")}</p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 gap-8 sm:grid-cols-3">
            <FooterCol title="Library" links={[t("browse"), t("powerpoint"), t("images"), t("video")]} />
            <FooterCol title="Account" links={[t("signIn"), t("createAccount"), t("upload"), t("myUploads")]} />
            <FooterCol title="Info" links={["About", "License", "Privacy", "Terms"]} />
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-2 border-t pt-6 text-xs text-muted-fg sm:flex-row sm:items-center" style={{ borderColor: "hsl(var(--border))" }}>
          <span>© {new Date().getFullYear()} 606MEDIADOCS. {t("rights")}</span>
          <span className="font-serif italic">made with care</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-[0.22em] text-muted-fg">{title}</div>
      <ul className="mt-4 space-y-2 text-sm">
        {links.map((l) => (
          <li key={l}>
            <a href="#" className="text-ink transition-colors hover:text-accent">
              {l}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
